import React, { useState } from 'react'
import {BrowserRouter as Router , Route , Link} from 'react-router-dom'
import Footer from './components/Footer';
import Nav from './components/Nav'
import Home from './pages/Home';
import Founders from './pages/Founders';

function App() {

  const [isStaff , setIsStaff] = useState(false)

  function checkIsStaff(){
    setIsStaff(true)
  }

  return (
    <div className="App">
      <Nav />
      <Router>
        <Route path='/' exact component={Home}></Route>
        <Route path='/staff' exact render={() => <Founders isStaff={checkIsStaff} />}></Route>
      </Router>
      <Footer isStaff={isStaff}/>
    </div>
  );
}

export default App;
